// /components/routes/Dashboard/UpgradeModal.tsx
import React from 'react';
import '../../../styles/components/Dashboard.scss';

interface UpgradeModalProps {
  onClose: () => void;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({ onClose }) => {
  return (
    <div className="upgrade-modal">
      <div className="modal-content">
        <h2>Upgrade Your Subscription</h2>
        <p>Unlock the full potential of your dashboard with a Premium Tier Subscription.</p>
        <button className="upgrade-button" onClick={onClose}>
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default UpgradeModal;